module.exports = __webpack_public_path__ + "img/2A_old.0fe4d76f.jpg";